export default "__VITE_ASSET__HjGYsJYV__ 100w";